export default {
  getUserInfo: (state) => state,
  getPermission: (state) => state.permision,
};
